export default "__VITE_ASSET__CGF5o1pG__"